/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_ProbingInputs */



/**
* | output |
* | --- |
* | "Reading the file..." |
*
* @param {Subtitle_Extract_ProbingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_probing = /** @type {((inputs?: Subtitle_Extract_ProbingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_ProbingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture du fichier...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei wird gelesen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettura del file in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чтение файла...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leyendo el archivo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在读取文件……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल पढ़ी जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lendo o arquivo...")
	return /** @type {LocalizedString} */ ("Reading the file...")
});